import axios from "axios";
import { toast } from "react-toastify";

export const forgotPassword = (email) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/forgot-password`,
				data: {
					email: email,
				},
			});
			
			toast.success(data.message || "Password reset code has been sent to your email.");
			return "success";
		} catch (error) {
			console.log(error.message);
			const errorMessage = error.response?.data?.message || "Failed to send reset code. Please try again.";
			toast.error(errorMessage);
			return "error";
		}
	};
};
